export enum EnumCardFieldTypes {
  "wysiwyg" = "wysiwyg",
  "asset"  ="asset",
}